module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("    © 2013 By Stephen M. Hood")])]), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("    All rights reserved. No part of this publication may be reproduced, stored in a"), _c('br'), _vm._v("\nretrieval system, or transmitted, in any form or by any means, electronic, mechanical,"), _c('br'), _vm._v("\nphotocopying, recording, or otherwise, without the prior written permission of the"), _c('br'), _vm._v("\npublisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("    Hood, Stephen M."), _c('br'), _vm._v("\n    John Bell Hood: the Rise, Fall, and Resurrection of a Confederate General /"), _c('br'), _vm._v("\nStephen M. Hood. — First edition."), _c('br'), _vm._v("\n    pages cm"), _c('br'), _vm._v("\n    Includes bibliographical references and index."), _c('br'), _vm._v("\n    EPUB ISBN 978-1-61121-140-5"), _c('br'), _vm._v("\n    PRINT ISBN 978-1-61121-141-2"), _c('br'), _vm._v("\n\n    1. Hood, John Bell, 1831-1879. 2. Generals—Confederate States of America—"), _c('br'), _vm._v("\nBiography. 3. United States—History—Civil War, 1861-1865—Biography. 4. United"), _c('br'), _vm._v("\nStates—History—Civil War, 1861-1865—Campaigns. I. Title."), _c('br'), _vm._v("\n    E467.1.H58H66 2013"), _c('br'), _vm._v("\n    355.0092—dc23"), _c('br'), _vm._v("\n    [B]"), _c('br'), _vm._v("\n    2013010919")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  }), _c('br'), _vm._v("\n    Published by"), _c('br'), _vm._v("\n    Savas Beatie LLC"), _c('br'), _vm._v("\n    989 Governor Drive, Suite 102"), _c('br'), _vm._v("\n    El Dorado Hills, California 95762")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("    Phone: 916-941-6896"), _c('br'), _vm._v("\n    (E-mail) ")]), _c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_vm._v("sales@savasbeatie.com")]), _c('br'), _vm._v("\n    (Website) "), _c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("    Savas Beatie titles are available at special discounts for bulk purchases in the"), _c('br'), _vm._v("\nUnited States by corporations, institutions, and other organizations. For more details,"), _c('br'), _vm._v("\nplease contact Special Sales, P.O. Box 4527, El Dorado Hills, CA 95762, or you may"), _c('br'), _vm._v("\ne-mail us at sales@savasbeatie.com, or visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")]), _vm._v(" for"), _c('br'), _vm._v("\nadditional information.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("    Printed in the United States of America.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0